import * as moment from 'moment-timezone';
import FeatherIcon from "feather-icons-react";
import React from "react";
import {MODULE, VIEW} from "./enum";

export function isEmpty(obj) {
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

export function batteryReading(value,low,high){
  if (value > 150 || value < 75) {
      value = (value - low) / (high - low);
      value = value < 0 ? 0.0 : value > 1 ? 1.0 : value;
  } else {
      value = -1.0;
  }
  return Math.round(value * 100);

}

export function isAllFalse(obj) {
  for (let prop in obj) {
    if (obj[prop]) {
      return false;
    }
  }

  return true;
}

export function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export function isDeviceOnline(time, interval) {
  if (!time) {
    return false;
  }

  interval = interval * 2;

  const today = new Date();
  const ist = moment.tz(time, 'Asia/Colombo');
  const ut = ist.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const diffMs = (today - ut);
  const diffMinutes = Math.round(diffMs / 60000);
  return diffMinutes <= interval;
}

export function toCapsFirst(name) {
  if (name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLocaleLowerCase();
  } else {
    return "";
  }
}

export function updateStateArray(values) {
  return values.map((item, index) => {
    return {...item, uiUpdate: index + new Date()}
  })
}

export function convertRoleIdToUserRole(roleId) {
  let userRole = "";
  switch (roleId) {
    case 1 :
      userRole = "Super";
      break;
    case 5 :
      userRole = "System Maintenance User";
      break;
    case 10 :
      userRole = "Account User";
      break;
    case 100 :
      userRole = "Corporate User";
      break;
    case 200 :
      userRole = "Corporate Admin User";
      break;
    case 1000 :
      userRole = "Farm User";
      break;
    case 2000 :
      userRole = "Agro Inspector";
      break;
    case 10000 :
      userRole = "Plot User";
      break;
  }

  return userRole;
}

export function timeDurationForGraph(Time) {
  const diffDays = Math.floor(Time / 86400000); // days
  const diffHrs = Math.floor((Time % 86400000) / 3600000); // hours
  const diffMins = Math.round(((Time % 86400000) % 3600000) / 60000); // minutes
  if (diffDays === 0) {
    if (diffHrs === 0) {
      return (diffMins + " minutes");
    }
    return (diffHrs + " hours, " + diffMins + " minutes");
  }
  return (diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes");
}

export function timeDurationMinutes(startTime, endTime) {
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);
  const diffMs = (endDate - startDate);
  return diffMs;
}

export function timeDurationToReadableForm(startTime, endTime) {
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);
  const diffMs = (endDate - startDate); // milliseconds between now & Christmas
  const diffDays = Math.floor(diffMs / 86400000); // days
  const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
  const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
  if (diffDays === 0) {
    if (diffHrs === 0) {
      return (diffMins + " minutes");
    }
    return (diffHrs + " hours, " + diffMins + " minutes");
  }
  return (diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes");
}

export function minsToDaysHoursMins(num) {
  const d = Math.floor(num/1440);
  const h = Math.floor((num-(d*1440))/60);
  const m = Math.round(num%60);
  if(d>0){
    return(d + " days, " + h + " hours, "+m+" minutes");
  }else{
    return(h + " hours, "+m+" minutes");
  }
}






export function isMobileView() {
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|L|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4));

}


export function convert24to12(time) {
  if (time) {
    time = time.split(':');
    let hour;
    if (12 <= time[0]) {
      if (parseInt(time[0]) === 12) {
        hour = 12;
      } else {
        hour = time[0] - 12;
      }
      if (hour.toString().length === 1) {
        hour = "0" + hour;
      }
      return hour + ':' + time[1] + ' pm';
    } else {
      if (parseInt(time[0]) === 0) {
        hour = 12;
      } else {
        hour = time[0];
      }
      if (hour.toString().length === 1) {
        hour = "0" + hour;
      }
      return hour + ':' + time[1] + ' am';
    }
  }
}

export function convert12Hto24H(time) {
  if (time) {
    const PM = time.match('pm');
    time = time.split(':');
    let min = time[1].split(' ')[0];
    let hour;
    if (PM) {
      const hourT = parseInt(time[0], 10);
      if (hourT < 12) {
        hour = 12 + hourT;
      } else {
        hour = 12;
      }
    } else {
      if (parseInt(time[0], 10) === 12) {
        hour = 0;
      } else {
        hour = time[0];
      }
    }
    if (min.match("pm") || min.match("am")) {
      min = min.slice(0, min.length - 2);
      min.trim();
    }

    if (hour.toString().length === 1) {
      hour = "0" + hour;
    }
    return hour + ':' + min;
  }
}

export function isValidDate(dateValue) {
  if (!dateValue) {
    return false
  }
  dateValue = dateValue.toISOString().slice(0, 10);
  return dateValue && dateValue.match(/^\d{4}-\d{2}-\d{2}$/) != null;
}

export function is24HRSTime(time) {
  if (!time) {
    return
  }
  return !(time.match("am") || time.match("pm"))
}

export function isEmail(str) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(str);

}


export function convertLowerCase(value) {
  if (!value) return "";
  return value.toString().toLowerCase();
}

export function dateFormat(date) {
  if (!date) return;
  let date1 = new Date(date);
  return new Date(date1.getTime() - (date1.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
}

export function dateAndTimeFormat(date) {
  if (!date) return;
  let date1 = new Date(date);
  return (new Date(date1.getTime() - (date1.getTimezoneOffset() * 60000)).toISOString().slice(0, 10)) + " " +
  (new Date(date1.getTime() - (date1.getTimezoneOffset() * 60000)).toISOString().slice(11, 16));
}

export function formatDisplayEnumValue(value) {
  if (!value) return "";
  return value.toString().replace("_", " ");
}

export function formatDisplayEnumValueNotification(value) {
  if (!value) return "";
  return value.toString().replace(/_/g, ' ');
}

export function getIcon(code) {
  switch (code) {
    case 'T':
      return (<div className="sensor-icon text-red"><FeatherIcon className={""} icon="thermometer"/></div>);
    case 'H':
      return (<div className="sensor-icon text-blue"><FeatherIcon className={""} icon="droplet"/></div>);
    case 'M':
    case 'IRO':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-moisture'/></div>);
    case 'CN':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-soil-temp'/></div>);
    case 'ST':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-soil-temp'/></div>);
    case 'EV':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-evaporation'/></div>);
    case 'WD':
    case 'WS':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-wind-direction'/></div>);
    case 'RF':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-rain-fall'/></div>);
    case 'SI':
      return (<div className="sensor-icon text-yellow"><span className='icon-sa-moisture icon-sun-intensity'/></div>);
    default:
      return (<div className="sensor-icon text-red"><FeatherIcon className={""} icon="thermometer"/></div>);

  }
}

export function formatDisplayValue(value) {
  if (value === "ERROR") {
    return "-";
  }
  return value;
}

export function isModule(url, module) {
  switch (module) {
    case MODULE.SMART_FARM:
      return !url.match("/daily-update") && !url.match("/cash-flow") && !url.match("/settings");
    case MODULE.CASH_FLOW:
      return url.match("/cash-flow");
    case MODULE.DAILY_UPDATE:
      return url.match("/daily-update");
    case MODULE.SETTINGS:
      return url.match("/settings");
    case MODULE.REPORT:
      return url.match("/reports");
    case MODULE.XINDICATE:
      return url.match("/xindicate");
  }
}


export function isFilterView(url, view) {
  switch (view) {
    case VIEW.DEPARTMENT:
      return url.match("/home");
    case VIEW.MACHINE:
      return url.match("/machine");
    case VIEW.REPORT:
      return url.match("/report");
    case VIEW.PERFORMANCE_GRAPH:
      return url.match("/performanceGraph");
    case VIEW.PERFORMANCE_TABLE:
      return url.match("/performanceTable");
    default:
      return url.match("/home");
  }
}

export function getModule(url) {
  if (!url.match("/daily-update") && !url.match("/cash-flow") && !url.match("/settings"))
    return MODULE.SMART_FARM;
  else if (url.match("/cash-flow"))
    return MODULE.CASH_FLOW
  else if (url.match("/daily-update"))
    return MODULE.DAILY_UPDATE
  else if (url.match("/settings"))
    return MODULE.SETTINGS
  else if (url.match("/reports"))
    return MODULE.REPORT;
}

export function changeActionFont(data){
  return  data.charAt(0).toUpperCase() +  data.toLowerCase().replace(/_/g, " ").slice(1);
}



export function isMobile() {
  return window.screen.width>1000
}

export const storeInLocalStorage = (name , value) =>{
    localStorage.setItem(name, JSON.stringify(value));
}

export const fetchFromLocalStorage = (name) =>{
  const item = JSON.parse(localStorage.getItem(name));
  
  if(item){
    return item;
  }else{
    return ''
  }
}

export function toFixed(val) {
	if (!Number.isInteger(val)) {
		const number = Number(val);
		return number.toFixed(2);
	}

  return val;
}

